<template>
  <!-- 行业报备详情 -->
  <div class="reportDetails">
    <commonHeader
      :tabs-list="tabsList"
      :tabs-default="activeName"
      @handleTabsClick="handleTabsClick"
    >
      <template #buttons>
        <!-- 编辑 -->
        <el-button plain v-if="echoData.allowEditAll || echoData.allowEditExpenseInfo" @click="editBtn">{{ $t('btn.Edit') }}</el-button>
        <!-- 召回修改 -->
        <el-button plain v-if="echoData.allowRecallEditReport" @click="recallBtn">{{ $t('btn.RecallC') }}</el-button>
        <!-- 驳回 -->
        <el-button plain v-if="echoData.allowApprove" @click="agreeRejectBtn(0)">{{ $t('btn.Rejected') }}</el-button>
        <!-- 同意 -->
        <el-button plain v-if="echoData.allowApprove" @click="agreeRejectBtn(1)">{{ $t('btn.Agree') }}</el-button>
        <!-- 取消报备 -->
        <el-button v-if="isReport && isReportStatus" plain @click="cancelReport">{{ $t('btn.CancelFil') }}</el-button>
        <!-- 转申请 -->
        <el-button v-if="isReport && isReportStatus" type="primary" @click="submitBtn">{{ $t('btn.TransferApp') }}</el-button>
      </template>
    </commonHeader>
    <!--费用归属-->
    <activistyCostAttribution v-if="requestFlage && activeName === 'basicInfo'" ref="activistyCostAttribution" :echo-data="echoData" />
    <!-- 基本信息 -->
    <basicInfo v-if="requestFlage && activeName === 'basicInfo'" :echo-data="echoData" />
    <!-- 活动信息 -->
    <activityInfo v-if="requestFlage && activeName === 'basicInfo'" :echo-data="echoData" />
    <!-- 重点拟邀请客户 -->
    <div class="common_group" v-if="requestFlage && echoData.mactJoinCustomerList && echoData.mactJoinCustomerList.length > 0 && activeName === 'basicInfo'">
      <div class="title">
        <img src="@/assets/images/userIcon.png">
        <span>{{ $t('industryReport.zdnyqkf') }}</span>
      </div>
      <commonTable ref="statisticsTable" style="margin-bottom:20px" v-show="!$store.state.useSimplifiedForm" />
      <commonTable ref="reportDetailsCustomerTable" />
    </div>
    <!-- 活动目标 -->
    <activityTargetValue :edit-echo-data="echoData" v-if="!$store.state.useSimplifiedForm && requestFlage && activeName === 'basicInfo'" />
    <!-- 重点参会/落地区域 -->
    <attendMeetings
      v-if="requestFlage && this.echoData.marketActivity.isNationalRelease && activeName === 'basicInfo'"
      :landing-region-list="echoData.landingRegionList"
      :activity-classification-code="echoData.marketActivity.activityClassificationCode"
    />
    <!-- 活动附件 -->
    <div class="common_group" v-if="echoData.attachFileList && echoData.attachFileList.length > 0 && activeName === 'basicInfo'">
      <div class="title">
        <img src="@/assets/images/fileIcon.png">
        <span>{{ $t('file.aa') }}</span>
      </div>
      <commonTable ref="activityDetailsFileTable" />
    </div>
    <!-- 活动物料 -->
    <activistyMaterial
      v-if="requestFlage && activeName === 'activistyMaterial'"
      :toolkit="{
        activityToolkit: echoData.marketActivityExpand.activityToolkit,
        activityName: echoData.marketActivity.activityName
      }"
    />
    <!-- 审批弹框 -->
    <agreeDialog
      :approved="assigneeName"
      :dialog-title="agreeDialogTitle"
      :echo-data="echoData"
      :agree-dialog-visible="agreeDialogVisible"
      @agreeSubHandle="agreeSubHandle"
      @dialogCloseHandle="agreeDialogCloseHandle"
    />
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader';
import activistyCostAttribution from './children/activityQuery/industryActivistyCostAttribution.vue';
import basicInfo from './component/activityDetails/basicInformation/basicInfo';
import activityInfo from './component/activityDetails/basicInformation/industryActivityInfo';
import agreeDialog from './component/activityDetails/activistyCostAttribution/agreeDialog';
import attendMeetings from './component/activityDetails/basicInformation/attendMeetings';
import activityTargetValue from '@/views/activitieList/children/activityQuery/industryActivityTargetValue.vue';
import activistyMaterial from './children/activityQuery/industryActivistyMaterial.vue';
import { activityQuery, activityQueryDetails } from './service';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import commonTable from 'components/commonTable';
import { TableColumns, TableRow } from '@/utils/tableOptions';

export default {
  name: 'IndustryReportDetails',
  data () {
    return {
      tabsList: [
        {
          name: 'basicInfo',
          label: this.$t('industryReport.hybblb.bxxq.jbxx')
        }
      ],
      activeName: 'basicInfo',
      echoData: {},
      requestFlage: false,
      fileIconfont: {
        pdf: require('@/assets/images/iconfont-pdf.png'),
        doc: require('@/assets/images/iconfont-doc.png'),
        img: require('@/assets/images/iconfont-img.png'),
        ppt: require('@/assets/images/iconfont-ppt.png'),
        universal: require('@/assets/images/iconfont-universal.png'),
        xls: require('@/assets/images/iconfont-xls.png')
      },
      assigneeName: '',
      agreeDialogTitle: '',
      agreeRejectFlage: '', // 判断点的是同意还是驳回
      agreeDialogVisible: false,
      isReportStatus: false
    };
  },
  components: {
    commonHeader,
    activistyCostAttribution,
    basicInfo,
    activityInfo,
    commonTable,
    agreeDialog,
    attendMeetings,
    activityTargetValue,
    activistyMaterial
  },
  computed: {
    isReport () {
      let { userId } = this.$store.state.userInfo.sysUser;
      const isCurrentUser = this.echoData.marketActivity && this.echoData.marketActivity.applyUserId === userId;
      const isReportComplete = this.echoData.marketActivity && this.echoData.marketActivity.activityClassificationCode !== 'AC_01';
      return isReportComplete && isCurrentUser;
    }
  },
  watch: {
    activeName: {
      immediate: true,
      handler (val) {
        if (val) {
          // 初始化数据
          val === 'basicInfo' && this.getEchoData();
        }
      }
    }
  },
  methods: {
    // 取消报备
    cancelReport () {
      this.$confirm(this.$t('newApp.Ycon'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        newApplicationFormApi.cancelReport(this.$route.query.activityCode).then(res => {
          if (res.status === '200') {
            this.$message.success(this.$t('general.OperSucc'));
            this.getEchoData();
            this.$router.go(0);
            // this.$router.push('/reportList');
          }
        });
      }).catch(() => {
      });
    },
    submitBtn () {
      const marketingForm = this.echoData.marketActivityExpand && this.echoData.marketActivityExpand.marketingForm;
      const path = marketingForm === 1 ? '/activityTransferApplication' : '/quickTransferApplication';
      // 跳转到报备审批完成页面
      this.$router.push({
        path,
        query: {
          activityCode: this.$route.query.activityCode,
          metaActive: '/industryReportList'
        }
      });
    },
    handleTabsClick (val) {
      this.activeName = val.name;
    },
    editBtn () {
      // 只能编辑费用归属
      this.$store.commit('newApplication/setEditFlag', 3);
      this.$router.push({
        path: '/editIndustryReportApplication',
        query: {
          activityCode: this.$route.query.activityCode,
          metaActive: this.$route.query.metaActive
        }
      });
    },
    fileDownloadBtn (row) {
      activityQueryDetails.getDownloadUrl(row.fileId).then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    loadStatisticsTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.ca'))
          ._data('ca')
          ._width('15%')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noocc'))
          ._data('noocc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noucc'))
          ._data('noucc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolcc'))
          ._data('nolcc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.noncc'))
          ._data('noncc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nocfuc'))
          ._data('nocfuc')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nolccx'))
          ._data('nolccx')
      );

      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.inviteCustomer.nonlcc'))
          ._data('nonlcc')
      );

      let column = tableRow._cols();
      this.$refs.statisticsTable.setColumn(column, {
        page: false
      });
    },
    loadFileTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('file.Na'))
          ._data('fileName')
          ._width('200')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              let format = row.fileName.split('.')[1];
              let imgUrl = '';
              switch (format) {
                case 'jpg':
                case 'png':
                case 'gif':
                  imgUrl = this.fileIconfont.img;
                  break;
                case 'pdf':
                  imgUrl = this.fileIconfont.pdf;
                  break;
                case 'doc':
                case 'docx':
                  imgUrl = this.fileIconfont.doc;
                  break;
                case 'ppt':
                case 'pps':
                case 'pptx':
                  imgUrl = this.fileIconfont.ppt;
                  break;
                case 'xls':
                case 'xlsx':
                  imgUrl = this.fileIconfont.xls;
                  break;
                default:
                  imgUrl = this.fileIconfont.universal;
              }
              return (
                <div class="table_file">
                  <img src={ imgUrl } />
                  <span>{ row.fileName }</span>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('')
          ._width('100')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="primary" onClick={ () => { this.fileDownloadBtn(row); } }>
                    <i class="iconfont icon-shangchuan-icon" />
                    {this.$t('general.Download')}
                  </el-button>
                </div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title('上传时间')
          ._data('createTime')
          ._width('300')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.activityDetailsFileTable.setColumn(column, {
          page: false
        });
        this.$refs.activityDetailsFileTable.loadStaticTable(this.echoData.attachFileList);
      });
    },
    agreeDialogCloseHandle () {
      this.agreeDialogVisible = false;
    },
    agreeRejectBtn (val) {
      let selected = [];
      if (this.$refs.activistyCostAttribution) {
        selected = this.$refs.activistyCostAttribution.getCheckedItem();
      }
      if (selected.length > 0) {
        activityQueryDetails.getReportProcessHistory(selected[0].id).then(res => {
          if (res.status === '200') {
            let { mactFlowLogReportList } = res.data;
            this.assigneeName = mactFlowLogReportList[mactFlowLogReportList.length - 1].assigneeName;
            this.agreeDialogTitle = val ? this.$t('btn.Agree') : this.$t('btn.Rejected');
            this.agreeRejectFlage = val;
            this.agreeDialogVisible = true;
          }
        });
      } else {
        this.$message.warning(this.$t('approvalCenter.PsaeiuFA'));
      }
    },
    agreeSubHandle (data) {
      const baseParams = {
        reason: data.reason === '同意' ? '' : data.reason,
        directors: data.directors
      };
      let requestUrl = this.agreeRejectFlage ? activityQueryDetails.reportApproval : activityQueryDetails.reportReject;
      const checkedItems = (this.$refs.activistyCostAttribution && this.$refs.activistyCostAttribution.getCheckedItem()) || [];
      if (!checkedItems.length) {
        this.$message.warning(this.$t('approvalCenter.PsaeiuFA'));
        return;
      }

      this.$store.commit('setSubPageLoading', true);

      const requests = checkedItems.map(item => {
        // 关键：为每个条目生成独立参数对象，避免 taskId 被后续覆盖
        const reqParams = { ...baseParams, taskId: item.taskId };
        return requestUrl(reqParams);
      });
      Promise.all(requests).then(results => {
        const allSuccess = results.every(r => r && r.status === '200');
        if (!allSuccess) {
          // 不跳转接口异常提示·
          return; // 终止后续成功逻辑
        }
        // 全部成功才继续
        this.agreeDialogVisible = false;
        this.$message.success(this.agreeRejectFlage ? this.$t('general.AppSucc') : this.$t('general.Rejected'));
          this.$store.dispatch('getPendingApprovalNum');
        this.$router.push({
          path: this.$route.query.metaActive ? this.$route.query.metaActive : '/industryReportList'
        });
      })
      .catch(err => {
        console.error('[approve error]', err);
        this.$message.error('审批请求失败');
      })
      .finally(() => {
        this.$store.commit('setSubPageLoading', false);
      });
    },
    recallBtn () {
      this.$confirm('确定召回修改该活动?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        activityQuery.reportRecall(this.$route.query.activityCode).then(res => {
          if (res.status === '200') {
            this.$router.push('/drafts');
            this.$message.success('操作成功');
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    loadCustomerTable () {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.CustomerName'))
          ._data('clientName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ci'))
          ._width('10%')
          ._data('isChannel')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.catt'))
          ._width('10%')
          ._data('accountMarked')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>{row.accountMarked || '--'}</div>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bo'))
          ._data('businessChance')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.newBusOpp'))
          ._width('200px')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row }) => {
              return (
                <span>
                  {
                    row.newBusOpp === 1 ? this.$t('general.yes') : (row.newBusOpp === 0 ? this.$t('general.no') : '--')
                  }
                </span>
              );
            }
          })
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.pdty'))
          ._data('output')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cc'))
          ._data('columnName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.bc'))
          ._data('mustFollowCustomer')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccd'))
          ._data('isOldAccount')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccon'))
          ._data('name')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.ADList.ContactNumber'))
          ._data('phone')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.ccat'))
          ._data('entityType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.cst'))
          ._data('channelContractType')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.noc'))
          ._data('circleName')
          ._width('10%')
      );
      tableRow.push(
        new TableColumns()
          ._title(this.$t('newApp.Customers.wtb'))
          ._data('coconstructionOrNot')
          ._width('10%')
      );
      let column = tableRow._cols();
      this.$nextTick(() => {
        this.$refs.reportDetailsCustomerTable.setColumn(column, {
          page: true
        });
        this.$refs.reportDetailsCustomerTable.loadStaticTable(this.echoData.mactJoinCustomerList, this.echoData.mactJoinCustomerList.length);
        const tableList = this.echoData.mactJoinCustomerList.filter((item, index, arr) => {
          return arr.findIndex(t => t.clientName === item.clientName) === index;
        });
        this.loadStatisticsTable();
        let statistics = {
          ca: {},
          noocc: 0,
          noucc: 0,
          nolcc: 0,
          noncc: 0,
          nocfuc: 0,
          nolccx: 0,
          nonlcc: 0,
          tbps: 0
        };

        tableList.forEach(item => {
          // 统计数据，拟邀请客户统计
          // 统计start
          let k = item.accountMarked ? (item.accountMarked === '--' ? '空' : item.accountMarked) : '空';
          if (!statistics.ca[k]) {
            statistics.ca[k] = 0;
          }
          statistics.ca[k]++;
          if (item.isOldAccount) {
            if (item.isOldAccount === '老客户') {
              statistics.noocc++;
            }
          }
          if (item.columnName) {
            if (item.columnName === '营销系统客户') {
              statistics.noucc++;
            }
            if (item.columnName === '列名客户') {
              statistics.nolcc++;
            }
            if (item.columnName === '非列名客户') {
              statistics.noncc++;
            }
            if (item.columnName === '营销系统渠道') {
              statistics.nocfuc++;
            }
            if (item.columnName === '列名渠道') {
              statistics.nolccx++;
            }
            if (item.columnName === '非列名渠道') {
              statistics.nonlcc++;
            }
          } else {
            statistics.noncc++;
          }
          // 统计end
        });
        // for (let i of this.statisticsTable) {
        //   this.$refs.statisticsTable.removeRow(i)
        // }
        let caContent = [];
        for (let k in statistics.ca) {
          caContent.push(`${k}${this.$t('newApp.ADList.no')}：${statistics.ca[k]}`);
        }

        const statisticsRow = {
          ...statistics,
          ca: caContent.length > 0 ? caContent.join('，') : '--'
        };
        // this.$refs.statisticsTable.insertRow(statisticsRow)
        this.$refs.statisticsTable.loadStaticTable([statisticsRow]);
      });
    },

    getEchoData () {
      this.$store.commit('setSubPageLoading', true); // 加载中动画开启
      // 请求接口 获取响应数据 传参 报备编码
      activityQueryDetails.getReportBasicInfoData(this.$route.query.activityCode).then(res => {
        if (res.status === '200') {
          this.echoData = res.data;// 申请全部数据暂存
          // 根据活动的 formType 设置简化表单状态（formType 为空时视为完整表单）
          this.$store.commit('setUseSimplifiedForm', this.echoData && this.echoData.marketActivity && this.echoData.marketActivity.formType === 'simplified');
          const { mactExpenseBelongVOList } = res.data;
          const isApprovalFinished = mactExpenseBelongVOList.some(item => item.mactExpenseBelong.stat === 101);
          const approvalCode = [100];
          const isApprovalRejected = mactExpenseBelongVOList.some(item => approvalCode.includes(item.mactExpenseBelong.stat));
          // 模板费用(EI201)不允许转申请
          const hasTemplateExpense = mactExpenseBelongVOList.some(item => item.mactExpenseBelong.expenseTypeCode === 'EI201');
          this.isReportStatus = isApprovalFinished && !isApprovalRejected && !hasTemplateExpense;
          if (res.data.marketActivityExpand.activityToolkit) {
            this.tabsList = [
              {
                name: 'basicInfo',
                label: this.$t('industryReport.hybblb.bxxq.jbxx')
              },
              {
                name: 'activistyMaterial',
                label: this.$t('industryReport.hybblb.bxxq.hdwl')
              }
            ];
          }
          this.requestFlage = true; // 判断是否展示 基本信息 活动信息 费用归属
          if (this.echoData.mactJoinCustomerList.length > 0) {
            this.loadCustomerTable(); // 重点拟邀请客户列表
          }
          if (this.echoData.attachFileList && this.echoData.attachFileList.length > 0) {
            this.loadFileTable(); // 附件列表
          }
        }
        this.$store.commit('setSubPageLoading', false); // 加载中动画关闭
      });
    }
  },
  beforeDestroy () {
    this.$store.commit('setUseSimplifiedForm', false);
  },
  mounted () {
    if (this.$route.query.activityCode) {
      // 初始化数据
      this.getEchoData();
    }
  }
};
</script>

<style scoped>

</style>
